import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Spinner } from '@/components/ui/spinner';
import { useChurchSwitchingStore } from '@/stores/church-switching-store';

/** Blocks interaction while the console moves into another church workspace. */
export const ChurchSwitchingDialog = () => {
  const { t } = useTranslation('churches');
  const active = useChurchSwitchingStore((state) => state.active);
  const mode = useChurchSwitchingStore((state) => state.mode);
  const churchName = useChurchSwitchingStore((state) => state.churchName);

  const title =
    mode === 'join' ? t('switcher.joiningTitle') : t('switcher.switchingTitle');

  let description: string;
  if (churchName) {
    description =
      mode === 'join'
        ? t('switcher.joiningDescription', { churchName })
        : t('switcher.switchingDescription', { churchName });
  } else {
    description =
      mode === 'join'
        ? t('switcher.joiningDescriptionGeneric')
        : t('switcher.switchingDescriptionGeneric');
  }

  return (
    <Dialog open={active}>
      <DialogContent size="sm" hideCloseButton aria-describedby="church-switching-description">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody contentClassName="flex items-center gap-3 py-2">
          <Spinner className="size-5 shrink-0 text-brand" />
          <p id="church-switching-description" className="text-body-sm text-fg-secondary">
            {description}
          </p>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};
